import * as tslib_1 from "tslib";
import { Binding } from '../common/binding';
import { Component } from '../common/component';
var Data = /** @class */ (function (_super) {
    tslib_1.__extends(Data, _super);
    function Data(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'binding';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                _this[key] = new Binding(obj[key]);
            }
        });
        return _this;
    }
    Data.prototype.toJSON = function () {
        var result = { "binding": null, "type": "Data" };
        if (this.binding) {
            result["binding"] = this.binding.toJSON();
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    Data.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Data;
}(Component));
export { Data };
//# sourceMappingURL=data.js.map